// @flow

import React, { Component, Fragment } from "react";
import classNames from "classnames";
import type { WidgetProps } from "@rjsf/utils";
import Radio from "../../radio";

type Props = $Exact<{
  ...WidgetProps,
  options: Object,
}>;

class RadioWidget extends Component<Props> {
  parseValue(value: string) {
    if (this.props.schema.type === "boolean") {
      return value === "true";
    }

    return value;
  }

  handleChange = (event: Object): void => {
    this.props.onChange(
      event.target.value === "" ? this.props.options.value : this.parseValue(event.target.value),
    );
  };

  render() {
    const props = Object.assign({}, this.props, {
      autoFocus: this.props.autofocus,
      onChange: this.handleChange,
    });

    delete props.formContext;
    delete props.autofocus;
    delete props.rawErrors;
    delete props.registry;
    delete props.schema;

    return (
      <div className="schema-form-widget-radio">
        {props.options.enumOptions.map(option => (
          <Radio
            readOnly={props.readonly}
            disabled={props.disabled}
            className="form-control"
            key={option.value}
            {...Object.assign({}, props, option, {
              id: `${props.id}.${option.value}`,
              name: `${props.id}.${option.value}`,
              className: props.className,
              checked: props.value === option.value,
            })}
          />
        ))}
      </div>
    );
  }
}

export default RadioWidget;
